// Every click modifies the original data which causes processing, which means that the arrays for the groups
// are not the same object. Must do a deep(ish) comparison of the groups instead
function isSameGroup (groupA, groupB) {
  if (!groupA || !groupB || groupA.length !== groupB.length) {
    return false
  }
  for (var i = 0; i < groupA.length; i++) {
    if (!groupA[i] || !groupB[i] || groupA[i].content !== groupB[i].content || groupA[i].type !== groupB[i].type) {
      return false
    }
  }
  return true
}

// Implements shift click functionality for recursive items (e.g. text responses)
export default {
  methods: {
    checkboxClick ($event) {
    // var that = this
      var index = $event.index
      var responseGroup = $event.group
      var evt = $event.event
      var slice = $event.slice
      var rids = []
      // This represents the state that the checkbox will be
      var isChecked = !responseGroup[index].show
      if (evt.shiftKey && this.lastChecked && isSameGroup(this.lastChecked.group, responseGroup)) {
        // If the index is higher, that means we're clicking a lower checkbox
        var direction = index > this.lastChecked.index ? 'down' : 'up'
        if (direction === 'down') {
          for (var i = this.lastChecked.index; i <= index; i++) {
            rids.push(responseGroup[i].rid || responseGroup[i].sessionId)
            this.$set(responseGroup[i], 'show', isChecked)
          }
        } else {
          for (i = this.lastChecked.index; i >= index; i--) {
            rids.push(responseGroup[i].rid || responseGroup[i].sessionId)
            this.$set(responseGroup[i], 'show', isChecked)
          }
        }
      }
      if (rids.length === 0) rids.push(responseGroup[index].rid || responseGroup[index].sessionId)
      this.$emit('registerrids', {
        rids: rids,
        show: isChecked,
        slice: slice
      })
      // Always set the last checked
      this.lastChecked = {
        group: responseGroup,
        index: index
      }
    }
  }
}
